import { RRendementProductionSchema_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric } from './GenericQ'
const Data = require('../json/RendementProduction.json')

//RendmntproductionSchema_Type
export function fetchRendementProduction(uuid: string): RRendementProductionSchema_Type {
  return fetchGeneric(Data, uuid)
}
export function fetchRendementProductionSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data)
}

export function fetchRendementProductionAll(): Array<RRendementProductionSchema_Type> {
  return Data
}
